import React from 'react'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAccountUI from '../../../components/superUser/transaction/BankAccountUI'
import LoanBankBalanceUI from '../../../components/superUser/transaction/LoanBankBalanceUI'
import CardUI from '../../../widgets/layout/CardUI.js'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import ButtonUI from '../../../widgets/action/ButtonUI.js'

const SuBankAccountPageUI = ({ context, errorList, loan, onRefreshClick, bankAccountList, loanBankBalance,
  upcomingCollection, upcomingCollectionCurrMonth, checked1, checked2, checkedTotal, onShowDetailsChange1, onShowDetailsChange2, onShowTotalDetailsChange,
  onTransferClick, genBankAccountNum, date, updateAmountClick
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={(!loan || !bankAccountList || !loanBankBalance || !errorList)}
    loan={loan} page='balances'
  >
    {
      (!loan || !bankAccountList || !loanBankBalance || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && bankAccountList && loanBankBalance &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Loan and Account Balances</b></span>
            </span>
          }
          right={
            onTransferClick && genBankAccountNum && context.permissions.includes('su_superuser') &&
            <ButtonUI label='Transfer to Clime1' onClick={onTransferClick} />
          }
        />

        <UpcomingCollectionTable upcomingCollection={upcomingCollection} checked={checked2} onShowDetailsChange={onShowDetailsChange2}
          title='Due Amounts as on' date={date} updateAmountClick={updateAmountClick}
        />

        <BankAccountUI loan={loan} context={context} onRefreshClick={onRefreshClick}
          bankAccountList={bankAccountList}
        />
        <LoanBankBalanceUI context={context} onRefreshClick={onRefreshClick}
          loanBankBalance={loanBankBalance}
        />
        <UpcomingCollectionTable upcomingCollection={upcomingCollectionCurrMonth} checked={checked1} onShowDetailsChange={onShowDetailsChange1}
          title='Due Amounts (Current)'
        />
      </>
    }
  </SuperUserLoanPageSF>

const isLastDayOfMonth = () => {
  const today = new Date();
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return today.getDate() === lastDay.getDate();
};

const UpcomingCollectionTable = ({ upcomingCollection, checked, onShowDetailsChange, title, date, updateAmountClick }) => {
  return (
    <CardUI className='g_m_top_100' >
      <div className='g_flex_h g_small'>
        <h4 style={{ color: 'black' }}>{title === "Due Amounts as on" ? `${title} ${date} ` : title}</h4>
        {
          isLastDayOfMonth() &&
          <ButtonUI label='Update Amount' onClick={updateAmountClick} />
        }
      </div>
      <span className='under_line' />
      <hr />
      {
        upcomingCollection &&
        <>
          <span className="g_flex_h g_muted g_small" style={{ marginBottom: '10px' }}>
            <span style={{ marginLeft: '580px' }}>
              Show Loan-wise
            </span>
            <SwitchUI checked={checked} onChange={onShowDetailsChange} />
          </span>
          <span>
            <table border={1} style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  <th className='g_m_left_50'>Particulars</th>
                  <th className='g_m_left_50' style={{ flex: 1, padding: '5px' }}>Payable</th>
                  {
                    checked && upcomingCollection.upcomingCollectionLoanDTOS &&
                    upcomingCollection.upcomingCollectionLoanDTOS.map((loan, j) =>
                      <th className='g_m_left_50' style={{ flex: 1, padding: '10px' }} key={j}>{loan.loanName}</th>
                    )
                  }
                </tr>
              </thead>
              <tbody>
                {[
                  { label: 'Outstanding Loan', field: 'totalOsLoanF5', loanField: 'osLoanF5' },
                  { label: 'Outstanding Balance', field: 'totalOsBalanceF5', loanField: 'osBalanceF5' },
                  { label: 'Outstanding Principal', field: 'totalOsPrincipalF5', loanField: 'osPrincipalF5' },
                  { label: 'Interest on Overdue Out of Pocket expenses', field: 'totalIntOnOverdueOOPEF5', loanField: 'intOnOverdueOOPEF5' },
                  { label: 'Out of Pocket expenses', field: 'totalOutOfPocketExpF5', loanField: 'outOfPocketExpF5' },
                  { label: 'Penal Charges', field: 'totalDefaultIntF5', loanField: 'defaultInterestF5' },
                  { label: 'Interest on overdue Interest', field: 'totalIntOnOverdueIntF5', loanField: 'intOnOverdueIntF5' },
                  { label: 'Interest on overdue Principal', field: 'totalIntOnOverduePrincipalF5', loanField: 'intOnOverduePrincipalF5' },
                  { label: 'Overdue Interest', field: 'totalOverdueIntF5', loanField: 'overdueIntF5' },
                  { label: 'Due Interest', field: 'totalDueIntF5', loanField: 'dueIntF5' },
                  { label: 'Overdue Principal', field: 'totalOverduePrincipalF5', loanField: 'overduePrincipalF5' },
                  { label: 'Due Principal', field: 'totalDuePrincipalF5', loanField: 'duePrincipalF5' },
                  { label: 'Total Due', field: 'totalDueF5', loanField: 'totalDueF5' }
                ].map((row, index) => (
                  <tr key={index}>
                    <td><b>{row.label}</b></td>
                    <td align="right">{upcomingCollection[row.field]}</td>
                    {checked && upcomingCollection.upcomingCollectionLoanDTOS &&
                      upcomingCollection.upcomingCollectionLoanDTOS.map((loan, j) => (
                        <td align="right" key={j}>{loan[row.loanField]}</td>
                      ))
                    }
                  </tr>
                ))}
              </tbody>
            </table>
          </span>
        </>
      }
    </CardUI >
  );
};


export default SuBankAccountPageUI
